export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  CHEF = 'ROLE_CHEF',
  BUCHHALTUNG = 'ROLE_BUCHHALTUNG',
}
